var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fetch)?_c('page-profile-edit-view',{attrs:{"loading":_vm.loading,"user":_vm.user,"info":_vm.info,"files":_vm.files,"userTags":_vm.selectedTags},on:{"upload":_vm.upload,"save":_vm.save,"updateUserTags":_vm.updateUserTags}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }